var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.572 5.7002H5.42816C5.24072 5.70009 5.05509 5.7369 4.88187 5.80854C4.70866 5.88017 4.55125 5.98522 4.41863 6.11769C4.28602 6.25015 4.18079 6.40745 4.10896 6.58058C4.03713 6.75371 4.00011 6.9393 4 7.12674V16.8738C4.00011 17.0612 4.03713 17.2468 4.10896 17.4199C4.18079 17.593 4.28602 17.7503 4.41864 17.8828C4.55126 18.0152 4.70867 18.1202 4.88189 18.1918C5.0551 18.2635 5.24073 18.3002 5.42816 18.3001H29.572C29.7595 18.3002 29.9451 18.2634 30.1183 18.1918C30.2914 18.1202 30.4488 18.0151 30.5814 17.8827C30.714 17.7502 30.8192 17.593 30.8911 17.4199C30.9629 17.2467 30.9999 17.0612 31 16.8738V7.12674C30.9998 6.74822 30.8492 6.38528 30.5814 6.11776C30.3137 5.85024 29.9506 5.70004 29.572 5.7002Z",
    fill: "url(#paint0_linear_20317_65953)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2652 8.53285C14.2652 8.91168 14.1147 9.27499 13.8468 9.54286C13.5789 9.81073 13.2156 9.96121 12.8368 9.96121C12.458 9.96121 12.0947 9.81073 11.8268 9.54286C11.5589 9.27499 11.4084 8.91168 11.4084 8.53285C11.4084 8.15403 11.5589 7.79072 11.8268 7.52285C12.0947 7.25498 12.458 7.10449 12.8368 7.10449C13.2156 7.10449 13.5789 7.25498 13.8468 7.52285C14.1147 7.79072 14.2652 8.15403 14.2652 8.53285Z",
    fill: "url(#paint1_linear_20317_65953)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2508 16.623H27.3075L24.8365 13.4315L27.0772 10.6893H25.2117L23.0114 13.4486V7.56431H21.4143V16.623H23.0114L23.0102 13.4563L25.2508 16.623ZM18.402 10.6882H19.9987V16.622H18.402V10.6882ZM15.3885 7.5625H16.9852V16.622H15.3885V7.5625ZM11.2375 10.629C10.7376 10.6283 10.2454 10.7518 9.80508 10.9885V7.5627H8.20825V13.657C8.20809 14.2561 8.38558 14.8417 8.71828 15.3399C9.05098 15.8381 9.52393 16.2264 10.0773 16.4558C10.6307 16.6852 11.2397 16.7453 11.8273 16.6286C12.4149 16.5118 12.9547 16.2235 13.3783 15.7999C13.802 15.3764 14.0906 14.8368 14.2076 14.2493C14.3246 13.6617 14.2647 13.0527 14.0355 12.4992C13.8064 11.9457 13.4182 11.4726 12.9202 11.1397C12.4221 10.8068 11.8365 10.6291 11.2375 10.629ZM11.2375 15.1148C10.9492 15.1148 10.6674 15.0293 10.4277 14.8692C10.188 14.709 10.0012 14.4814 9.89086 14.2151C9.78054 13.9487 9.75166 13.6557 9.80788 13.3729C9.86411 13.0902 10.0029 12.8305 10.2067 12.6266C10.4106 12.4228 10.6703 12.2839 10.953 12.2277C11.2357 12.1714 11.5288 12.2002 11.7951 12.3105C12.0615 12.4208 12.2891 12.6076 12.4493 12.8473C12.6095 13.087 12.695 13.3687 12.6951 13.657C12.6951 13.8485 12.6575 14.038 12.5843 14.2149C12.511 14.3918 12.4037 14.5525 12.2683 14.6879C12.133 14.8233 11.9723 14.9307 11.7954 15.0039C11.6185 15.0772 11.4289 15.1148 11.2375 15.1148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20317_65953",
    x1: 17.5001,
    y1: 18.2395,
    x2: 17.5001,
    y2: 5.76085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20317_65953",
    x1: 11.8264,
    y1: 9.54326,
    x2: 13.8472,
    y2: 7.52244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94F96"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlik);
export default __webpack_public_path__ + "static/media/blik.08dc22129da268a8ccdab5d2f9352730.svg";
export { ForwardRef as ReactComponent };